import React from 'react';
import {designSystemToken, Label} from '@lightricks/react-design-system';

function ButtonEndBadge({text}: {text: string}) {
  return (
    <Label
      size="sm"
      sx={{
        width: 16,
        height: 16,
        alignItems: 'center',
        textAlign: 'center',
        borderRadius: '100%',
        background: designSystemToken('semantic.fg.primary'),
        color: designSystemToken('semantic.bg.primary'),
      }}
      style={{fontSize: 9}}
    >
      {text}
    </Label>
  );
}

export default ButtonEndBadge;
